import * as React from 'react'

const DrizzleIcon = props => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7808 6.93727C16.7889 7.31338 16.6768 7.68948 16.4688 8.00157C16.1487 8.4897 15.5885 8.8338 14.9243 8.8338H2.68892C1.96072 8.8338 1.28853 8.40968 1.00045 7.73749C0.89642 7.48942 0.832403 7.21735 0.800394 6.94527C0.784389 6.77723 0.776387 6.60118 0.784389 6.42513C0.848407 5.00073 1.76066 3.57633 3.13704 3.76839C3.13704 3.76839 3.13705 3.76839 3.14505 3.76839C3.12904 3.56033 3.12904 3.36027 3.15305 3.16822C3.48114 0.503477 7.60229 -1.08096 9.4188 1.90387C9.56284 2.14393 9.69887 2.41601 9.81091 2.71209C11.6434 0.951602 14.8363 2.76811 14.2361 5.18478C13.836 6.79323 13.836 6.79323 14.2361 5.18478C15.3084 5.03274 16.0366 5.39284 16.4448 5.94499C16.6608 6.24908 16.7728 6.60118 16.7808 6.93727Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.53083 3.43955C9.50682 3.75964 9.4188 4.12774 9.13072 4.26378C8.88265 4.38381 8.57856 4.27178 8.3465 4.11974C8.11443 3.96769 7.90638 3.76764 7.6343 3.68762C7.10615 3.52757 6.57 3.87967 6.16989 4.25577C5.76978 4.63188 5.36167 5.072 4.81751 5.15202C4.32938 5.22404 3.83324 4.95997 3.52916 4.57586C3.3451 4.3358 3.21707 4.06372 3.13705 3.76764C3.13705 3.76764 3.13705 3.76764 3.14505 3.76764C2.86497 0.750798 7.46625 -1.29777 9.4188 1.89512C9.52283 2.39926 9.56284 2.9194 9.53083 3.43955Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.81678 5.58464C4.5287 5.84872 4.04856 5.71268 3.69646 5.88072C3.23233 6.10479 3.16832 6.75297 2.80021 7.12107C2.41611 7.50518 1.74392 7.48917 1.3038 7.16108L1.29579 7.15308C0.903686 6.857 0.743641 6.35286 0.839668 5.87272C1.07973 4.65638 1.93597 3.59209 3.12831 3.76814C3.12831 3.76814 3.12831 3.76814 3.13631 3.76814C3.1203 3.56008 3.1203 3.36002 3.14431 3.16797C3.85651 3.296 4.51269 3.76013 4.83278 4.41632C4.92081 4.59237 4.98482 4.78442 5.00083 4.98448C5.02483 5.20054 4.97682 5.4326 4.81678 5.58464Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.0735 0.942182C6.99348 0.798142 6.84144 0.702115 6.67339 0.702115C6.25728 0.694113 5.84116 0.734124 5.48106 0.934179C5.36903 0.998197 5.265 1.07822 5.22499 1.19825C5.20899 1.25427 5.20898 1.31029 5.20898 1.3663C5.21699 1.48633 5.24099 1.61437 5.32102 1.70239C5.40104 1.79042 5.52107 1.82243 5.6331 1.82243C5.74513 1.81443 5.85717 1.76641 5.95319 1.70239C6.02521 1.65438 6.08923 1.59036 6.15325 1.54235C6.28128 1.44632 6.43333 1.39031 6.58537 1.3583C6.7054 1.33429 6.84144 1.32629 6.94547 1.26227C7.0655 1.19825 7.13752 1.04621 7.0735 0.942182Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.71291 1.87109C4.64089 1.87109 4.56887 1.8871 4.51286 1.93511C4.40083 2.03114 4.3048 2.15117 4.24878 2.29521C4.21677 2.37523 4.19277 2.47126 4.20077 2.55929C4.21677 2.64731 4.26479 2.73533 4.34481 2.77535C4.40883 2.80736 4.48085 2.80735 4.54487 2.79135C4.76893 2.75134 4.97699 2.58329 5.05701 2.36723C5.08902 2.27921 5.10502 2.18318 5.08102 2.09516C5.04901 1.96712 4.93698 1.8791 4.80094 1.8791L4.71291 1.87109Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.68141 4.23169C2.34532 4.2797 2.04123 4.45575 1.83318 4.71983C1.65713 4.95189 1.52909 5.23197 1.48908 5.52005C1.47308 5.60808 1.47308 5.71211 1.5451 5.76812C1.58511 5.80013 1.64112 5.80813 1.68914 5.81613C1.77716 5.82414 1.86519 5.82414 1.93721 5.79213C2.06524 5.72811 2.11326 5.58407 2.16127 5.45603C2.2653 5.19196 2.43334 4.91188 2.70542 4.82386C2.72143 4.81585 2.73743 4.81586 2.75343 4.80785C2.84946 4.78385 2.93749 4.71983 2.9775 4.6238C3.10553 4.39174 2.88147 4.19168 2.68141 4.23169Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2116 2.88014C10.1396 2.93616 10.0756 3.00018 10.0356 3.0802C9.99555 3.15222 9.98754 3.24024 10.0116 3.32027C10.0756 3.51232 10.2996 3.51232 10.4517 3.4323C10.5797 3.36828 10.6757 3.25625 10.7878 3.16022C10.9718 3.01618 11.1959 2.94416 11.4199 2.88014C11.492 2.86414 11.564 2.84013 11.628 2.79212C11.684 2.74411 11.724 2.66408 11.692 2.59206C11.66 2.52004 11.572 2.49604 11.492 2.48803C11.2359 2.46403 10.9718 2.49604 10.7398 2.60007L10.6277 2.64808C10.4757 2.7201 10.3396 2.79212 10.2116 2.88014Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3723 5.91154C14.5483 5.89554 14.7244 5.89554 14.8924 5.91955C15.1965 5.95156 15.4926 6.06359 15.6927 6.29565C16.2208 6.91182 15.8127 7.83208 15.1005 8.04814C14.8044 8.13617 14.4843 8.14417 14.1722 8.12816C13.7561 8.11216 13.332 8.05614 12.9799 7.83208C12.5078 7.528 12.3477 6.80779 12.7879 6.39968C12.9559 6.23964 13.18 6.15961 13.404 6.0956C13.7081 6.00757 14.0442 5.94355 14.3723 5.91154Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0983 6.88006C10.9383 6.96008 10.7862 7.07211 10.7142 7.18415C10.6422 7.28818 10.6662 7.40821 10.7062 7.51224C10.7382 7.59226 10.7702 7.67228 10.8342 7.7283C11.0183 7.90435 11.4424 7.89634 11.6424 7.76831C11.8185 7.66428 11.9545 7.40021 11.9225 7.19215C11.8985 7.05611 11.7785 6.90407 11.6665 6.83205C11.5144 6.74402 11.2984 6.78403 11.0983 6.88006Z"
      fill="#CBBEBB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.55472 11.8583C5.52271 11.9303 5.4827 11.9943 5.44269 12.0503C5.05058 12.6745 4.47442 12.8026 3.98629 12.5545C3.6662 12.3944 3.44213 12.1144 3.41013 11.7383C3.38612 11.4902 3.43413 11.2021 3.59418 10.882C3.83424 10.3939 4.41841 10.1538 4.82652 10.0338C5.0986 9.95376 5.37867 10.0978 5.4827 10.3619C5.64275 10.762 5.79479 11.3702 5.55472 11.8583Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.25747 11.9696C5.3695 11.9857 5.40951 12.1217 5.33749 12.2017C4.95338 12.6898 4.43324 12.7779 3.98512 12.5538C3.69703 12.4098 3.49698 12.1697 3.42496 11.8656C3.40895 11.7936 3.45697 11.7136 3.52899 11.6976C3.86508 11.6095 4.12115 11.9616 4.43324 12.0737C4.74533 12.1777 4.96139 11.9216 5.25747 11.9696Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.31361 10.5371C4.2736 10.5371 4.23359 10.5451 4.19358 10.5691C4.06554 10.6331 3.93751 10.7612 3.9055 10.9052C3.86549 11.0573 4.00153 11.2413 4.16157 11.1373C4.28961 11.0493 4.49766 10.8812 4.49766 10.7052C4.48966 10.5851 4.40964 10.5371 4.31361 10.5371Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.96143 12.0505C3.94543 12.0105 3.91342 11.9705 3.88141 11.9385C3.87341 11.9305 3.86541 11.9305 3.86541 11.9225C3.81739 11.8905 3.76138 11.8825 3.72137 11.9305C3.68136 11.9785 3.68936 12.0425 3.71336 12.0985C3.73737 12.1306 3.76138 12.1626 3.80139 12.1866C3.80939 12.1946 3.81739 12.2026 3.8334 12.2026C3.8494 12.2106 3.86541 12.2106 3.87341 12.2026C3.91342 12.2026 3.96143 12.1866 3.97744 12.1546C3.99344 12.1225 3.98544 12.0905 3.96944 12.0585C3.96143 12.0585 3.96143 12.0505 3.96143 12.0505Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.17654 12.1383C4.20855 12.1303 4.24856 12.1383 4.28057 12.1383C4.30457 12.1383 4.32058 12.1463 4.33658 12.1543C4.35259 12.1703 4.36059 12.1943 4.36059 12.2263C4.36059 12.2584 4.34459 12.2824 4.31258 12.2904C4.26456 12.3064 4.19254 12.3224 4.15253 12.2824C4.11252 12.2424 4.11252 12.1543 4.17654 12.1383Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5879 11.8583C13.5559 11.9303 13.5159 11.9943 13.4759 12.0503C13.0838 12.6745 12.5076 12.8026 12.0195 12.5545C11.6994 12.3944 11.4753 12.1144 11.4433 11.7383C11.4193 11.4902 11.4673 11.2021 11.6274 10.882C11.8674 10.3939 12.4516 10.1538 12.8677 10.0338C13.1398 9.95376 13.4199 10.0978 13.5239 10.3619C13.6679 10.762 13.828 11.3702 13.5879 11.8583Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2926 11.9696C13.4047 11.9857 13.4447 12.1217 13.3726 12.2017C12.9885 12.6898 12.4684 12.7779 12.0203 12.5538C11.7322 12.4098 11.5321 12.1697 11.4601 11.8656C11.4441 11.7936 11.4921 11.7136 11.5641 11.6976C11.9002 11.6095 12.1563 11.9616 12.4684 12.0737C12.7725 12.1777 12.9965 11.9216 13.2926 11.9696Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3468 10.5371C12.3068 10.5371 12.2668 10.5451 12.2268 10.5691C12.0987 10.6331 11.9707 10.7612 11.9387 10.9052C11.8987 11.0573 12.0347 11.2413 12.1948 11.1373C12.3228 11.0493 12.5309 10.8812 12.5309 10.7052C12.5229 10.5851 12.4348 10.5371 12.3468 10.5371Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.987 12.0505C11.971 12.0105 11.939 11.9705 11.907 11.9385C11.899 11.9305 11.891 11.9305 11.891 11.9225C11.843 11.8905 11.787 11.8825 11.7389 11.9305C11.6989 11.9785 11.7069 12.0425 11.7309 12.0985C11.7549 12.1306 11.779 12.1626 11.819 12.1866C11.827 12.1946 11.835 12.2026 11.851 12.2026C11.867 12.2106 11.883 12.2106 11.891 12.2026C11.931 12.2026 11.979 12.1866 11.995 12.1546C12.011 12.1225 12.003 12.0905 11.987 12.0585C11.995 12.0585 11.987 12.0505 11.987 12.0505Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2123 12.1383C12.2443 12.1303 12.2844 12.1383 12.3244 12.1383C12.3484 12.1383 12.3644 12.1463 12.3804 12.1543C12.3964 12.1703 12.4044 12.1943 12.4044 12.2263C12.4044 12.2584 12.3884 12.2824 12.3564 12.2904C12.3084 12.3064 12.2363 12.3224 12.1963 12.2824C12.1483 12.2424 12.1483 12.1543 12.2123 12.1383Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.29914 14.4516C9.26713 14.5156 9.22712 14.5796 9.19511 14.6356C8.81101 15.2358 8.25885 15.3558 7.78672 15.1238C7.47463 14.9717 7.26658 14.6917 7.22656 14.3396C7.20256 14.0995 7.25057 13.8194 7.40261 13.5073C7.63468 13.0432 8.19483 12.8031 8.59495 12.6911C8.85102 12.6191 9.1311 12.7551 9.22712 13.0032C9.37916 13.3953 9.53121 13.9875 9.29914 14.4516Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00247 14.5616C9.10649 14.5776 9.14651 14.7057 9.08249 14.7857C8.70638 15.2578 8.21024 15.3378 7.77812 15.1218C7.49805 14.9857 7.30599 14.7537 7.23397 14.4576C7.21797 14.3856 7.25798 14.3135 7.33 14.2895C7.65809 14.2095 7.89816 14.5456 8.20224 14.6496C8.50633 14.7617 8.72239 14.5136 9.00247 14.5616Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.09848 13.1777C8.05847 13.1777 8.01846 13.1857 7.98645 13.2017C7.85842 13.2658 7.73838 13.3858 7.70638 13.5298C7.67437 13.6819 7.7944 13.8579 7.94644 13.7539C8.07448 13.6659 8.27453 13.5058 8.26653 13.3378C8.26653 13.2257 8.18651 13.1777 8.09848 13.1777Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.7544 14.6343C7.7384 14.5943 7.70639 14.5543 7.67438 14.5303C7.66638 14.5303 7.66638 14.5223 7.65838 14.5143C7.61036 14.4823 7.55435 14.4743 7.51434 14.5223C7.47432 14.5703 7.48233 14.6343 7.50633 14.6823C7.52234 14.7143 7.55435 14.7464 7.58636 14.7624C7.59436 14.7704 7.60236 14.7704 7.61836 14.7784C7.63437 14.7864 7.64237 14.7864 7.65838 14.7864C7.69839 14.7864 7.7384 14.7704 7.76241 14.7384C7.77841 14.7143 7.77041 14.6743 7.7544 14.6503C7.7544 14.6423 7.7544 14.6423 7.7544 14.6343Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.97146 14.7223C8.00347 14.7143 8.04348 14.7223 8.07549 14.7223C8.09149 14.7223 8.1155 14.7303 8.1315 14.7383C8.14751 14.7543 8.15551 14.7783 8.15551 14.8023C8.15551 14.8343 8.13951 14.8583 8.1075 14.8663C8.05949 14.8824 7.99547 14.8984 7.94745 14.8583C7.90744 14.8263 7.90744 14.7383 7.97146 14.7223Z"
      fill="white"
    />
  </svg>
)

export default DrizzleIcon
